import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';

const SearchBar = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const searchContainerRef = useRef(null);

    // Function to fetch suggestions from API
    const fetchSuggestions = async (query) => {
        try {
            const response = await axios.get(`${BackendURL}/suggestions/${query}`);
            setSuggestions(response.data);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setSuggestions([]);
        }
    };

    // Function to fetch data from API
    const findProductsByName = async (searchName) => {
        try {
            const response = await axios.get(`${BackendURL}/search/${searchName}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    // SEARCH LOGIC:
    const searchFunction = async () => {
        const results = await findProductsByName(searchTerm);
        navigate('/search', { state: { results } });
        setSuggestions([]); // Clear suggestions after search
    };

    // Event handler for Enter key press
    const handleKeyPress = async (event) => {
        if (event.key === 'Enter') {
            await searchFunction();
        }
    };

    // Handle input change to fetch suggestions
    const handleInputChange = async (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value.length > 2) { // Fetch suggestions if input length > 2
            setShowSuggestions(true);
            await fetchSuggestions(value);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    // Handle suggestion click
    const handleSuggestionClick = async (suggestion) => {
        setSearchTerm(suggestion);
        setSuggestions([]);
        setShowSuggestions(false);
        await searchFunction();
    };

    // Handle input focus event to show suggestions if input length > 2
    const handleFocus = () => {
        if (searchTerm.length > 2 && suggestions.length > 0) {
            setShowSuggestions(true);
        }
    };

    // Handle click outside of search-container
    const handleClickOutside = (event) => {
        if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
            setShowSuggestions(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="search-container" ref={searchContainerRef}>
            <input
                type="text"
                className="search-input"
                value={searchTerm}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                onFocus={handleFocus}
                placeholder="Search..."
                id='search'
                autoComplete="off"
            />
            <button
                type="button"
                onClick={searchFunction}
                className="search-button"
            >
                Search
            </button>
            {showSuggestions && suggestions.length > 0 && (
                <div className="suggestions-dropdown">
                    {suggestions.map((suggestion, index) => (
                        <div
                            key={index}
                            className="suggestion-item"
                            onClick={() => handleSuggestionClick(suggestion)}
                        >
                            {suggestion}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchBar;
